import { RootState } from 'store/rootTypes';

export const ReceiverSelector = (state: RootState) => state.Receiver;
